import { render, staticRenderFns } from "./logistcsDialog.vue?vue&type=template&id=1bb93d78&scoped=true"
import script from "./logistcsDialog.vue?vue&type=script&lang=js"
export * from "./logistcsDialog.vue?vue&type=script&lang=js"
import style0 from "./logistcsDialog.vue?vue&type=style&index=0&id=1bb93d78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb93d78",
  null
  
)

export default component.exports